module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"all":"全て","indoor":"内部発生","outdoor":"外部侵入","other":"その他"},"en":{"all":"All","indoor":"Indoor","outdoor":"Outdoor","other":"Other"}}')
  delete Component.options._Ctor
}
